import React, { useRef, useState } from "react";

export function useHoldZoom() {
  const [zoomed, setZoomed] = useState(false);
  const [origin, setOrigin] = useState("50% 50%");
  const st = useRef({ timer: null, x: 0, y: 0, el: null, zoomed: false, justZoomed: false });
  const pos = (e, el) => {
    const r = el.getBoundingClientRect();
    return `${Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100))}% ${Math.max(0, Math.min(100, ((e.clientY - r.top) / r.height) * 100))}%`;
  };
  const reset = () => {
    clearTimeout(st.current.timer);
    if (st.current.zoomed) { st.current.justZoomed = true; setTimeout(() => { st.current.justZoomed = false; }, 350); }
    st.current.zoomed = false;
    setZoomed(false);
  };
  const handlers = {
    onPointerDown: (e) => {
      const el = e.currentTarget;
      st.current = { ...st.current, x: e.clientX, y: e.clientY, el };
      setOrigin(pos(e, el));
      st.current.timer = setTimeout(() => { st.current.zoomed = true; setZoomed(true); }, 180);
    },
    onPointerMove: (e) => {
      if (st.current.zoomed) { setOrigin(pos(e, st.current.el)); return; }
      if (Math.abs(e.clientX - st.current.x) > 10 || Math.abs(e.clientY - st.current.y) > 10) clearTimeout(st.current.timer);
    },
    onPointerUp: reset, onPointerCancel: reset, onPointerLeave: reset,
    onContextMenu: (e) => e.preventDefault(),
    onClickCapture: (e) => { if (st.current.justZoomed) { e.stopPropagation(); e.preventDefault(); } },
  };
  const style = (scale) => ({
    transform: zoomed ? `scale(${scale})` : "scale(1)", transformOrigin: origin,
    transition: "transform 220ms ease", WebkitTouchCallout: "none", userSelect: "none", touchAction: zoomed ? "none" : "pan-x pan-y",
  });
  return { zoomed, handlers, style };
}

export function HoldZoomImg({ scale = 2.2, style, className = "", ...props }) {
  const { handlers, style: zs } = useHoldZoom();
  const extra = style?.transform ? { ...style, transform: undefined } : style;
  return <img draggable={false} {...props} {...handlers} className={className} style={{ ...extra, ...zs(scale) }} alt={props.alt || ""} />;
}

export function HoldZoomBox({ scale = 1.8, className = "", children, ...props }) {
  const { zoomed, handlers, style: zs } = useHoldZoom();
  return <div {...props} {...handlers} className={`${className} ${zoomed ? "relative z-50" : ""}`} style={{ ...zs(scale), transformOrigin: "10% 40%" }}>{children}</div>;
}

export default HoldZoomImg;
